module.exports = __webpack_public_path__ + "static/media/Anvil.4782d7c2.png";